// src/pages/battle/Battlemap.constants.js

export const TILE_SIZE = 60;

export const DEFAULT_MISSION = {
  name: 'TACTICAL OPERATION',
  location: 'Unknown Sector',
  difficulty: 'medium',
  rewards: { funds: 5000, intel: 25, xp: 100 },
  type: 'combat'
};

export const DEFAULT_SQUAD = [
  { 
    id: 1, 
    name: 'SGT Mason', 
    rank: 'Sergeant', 
    classId: 'ranger', 
    unlockedSkills: [], 
    health: 100, 
    loadout: {} 
  },
  { 
    id: 2, 
    name: 'CPL Rivera', 
    rank: 'Corporal', 
    classId: 'sniper', 
    unlockedSkills: [], 
    health: 100, 
    loadout: {} 
  },
  { 
    id: 3, 
    name: 'PVT Chen', 
    rank: 'Private', 
    classId: 'support', 
    unlockedSkills: [], 
    health: 100, 
    loadout: {} 
  }
];

export const XP_VALUES = {
  campaign: 100,
  complex: 50,
  basic: 25
};

export const KILL_BONUS_XP = 10;